import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Snowflake } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const run = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setAuth(res.data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    if (sessionId) run();
    else navigate("/", { replace: true });
  }, [location, navigate, setAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <Snowflake className="w-10 h-10 text-primary animate-spin" />
      <p className="text-muted-foreground font-mono text-sm">Securing your cold-chain session…</p>
    </div>
  );
}
